/* eslint-disable react-hooks/rules-of-hooks */
import jwtDecode from 'jwt-decode'
import Cookies from 'js-cookie'
import { removeformatarCPFCNPJ } from 'src/utils/FormatterUtils'
import ILogin from 'src/interfaces/login'
import api from 'src/utils/Api'
import { AUTH_USER, FIND_BY_USER_LOGIN, USER_VALIDATE } from 'src/utils/Routes'
import {
  ErrorNotification,
  SuccessNotification,
} from '@components/common/notification'

const TOKEN_COOKIE_KEY: string = 'token'
const USER_COOKIE_KEY: string = 'user'
const DADOS_USUARIO: string = 'dados_usuario'
const ROLE: string = 'role'
const PERMISSIONS: string = 'permissions'
const NOME: string = 'nome'
const IMAGE_PATH: string = 'pathImage'

// Function to remove all cookies
const removeAllCookies = () => {
  const cookies = Object.keys(Cookies.get())
  cookies.forEach(cookie => {
    Cookies.remove(cookie)
  })
}

const clearAuthentication = () => {
  removeAllCookies()
}

export const loginAuth = (credentials: ILogin) => {
  credentials.login = removeformatarCPFCNPJ(credentials.login)

  return api
    .post(AUTH_USER, credentials)
    .then(response => {
      const token = response.data.token
      const user = jwtDecode(token)

      localStorage.setItem('menu-collapsed', 'true')

      Cookies.set(TOKEN_COOKIE_KEY, token, { expires: 1, secure: true })
      Cookies.set(USER_COOKIE_KEY, JSON.stringify(user), {
        expires: 1,
        secure: true,
      })

      const usuario = JSON.parse(Cookies.get(USER_COOKIE_KEY) ?? '{}')?.sub
      Cookies.set(DADOS_USUARIO, usuario, { expires: 1, secure: true })

      return api.get(FIND_BY_USER_LOGIN + response.data.login)
    })
    .then(userResp => {
      SuccessNotification({
        message: 'Seja bem vindo(a) ' + userResp.data.nome + ' !',
      })

      Cookies.set(IMAGE_PATH, userResp.data.documentos?.path ?? '')
      Cookies.set(NOME, userResp.data.nome)
      Cookies.set(ROLE, userResp.data.role)
      Cookies.set(
        PERMISSIONS,
        JSON.stringify(userResp.data.permissionUsers).toLowerCase()
      )

      return true
    })
    .catch(error => {
      ErrorNotification({
        message: error?.message,
      })
      return false
    })
}

export const clearDados = () => {
  removeAllCookies()
  clearAuthentication()
}

export const verifyUserExpired = async () => {
  const check = await api
    .get(USER_VALIDATE + `${Cookies.get(TOKEN_COOKIE_KEY)}`)
    .then(response => {
      if (!response.data) {
        removeAllCookies()
        clearAuthentication()
        return response.data
      }
      return response.data
    })
    .catch(() => {
      removeAllCookies()
      clearAuthentication()
      return false
    })
  return check
}
